import * as actionTypes from '../constants/userActionTypes';

const defaultState = {
    loading: false,
    errors:{}
  }
  
  export const supportingDocsReducers = (state=defaultState, action={}) => {
    switch (action.type) {

        // LOAD SUBSCRIPTION
        case actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_SUCCESS:
            return {
                ...state,
                loading: false,
                projectSupportingDocs: action.payload.data,
            }
        case actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_FAIL:
            return {
                ...state,
                error: action.payload
            }
        case actionTypes.LOAD_PROJECT_SUPPORTING_DOCS_RESET:
            return {
                ...state,
                error: null,
                message: null
            }
      
      default:
        return state;
    }
  }